function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/projectAuthorization/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'plan')
    }
}

let routes = [
    {
        name: 'authorizationList',
        path: '/ems/authorizationList',
        meta: {
            title: '项目授权'
        }
    },
    {
        name: 'authorizationDetail',
        path: '/ems/authorizationDetail',
        meta: {
            title: '项目授权'
        }
    },
    {
        name: 'authorizationEditor',
        path: '/ems/authorizationEditor',
        meta: {
            title: '新增人员'
        }
    },
    {
        name: 'checkUser',
        path: '/ems/projectAuthorization/checkUser',
        meta: {
            title: '新增人员'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/projectAuthorization.js